/* Landing sorteo fotomaton, The Only Fresh */
(function () {
  'use strict';

  function post(endpoint, form) {
    return fetch(endpoint, { method: 'POST', body: new FormData(form) }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json().catch(function () {
        return {};
      });
    });
  }

  function messenger(el) {
    return function (text, state) {
      if (!el) return;
      el.textContent = text || '';
      el.setAttribute('data-state', state || 'info');
    };
  }

  /* Form del sorteo */
  function initRaffle(root) {
    var form = root.querySelector('.ofs-form');
    if (!form) return;
    var say = messenger(form.querySelector('.ofs-msg'));
    var submit = form.querySelector('button[type="submit"]');
    var endpoint = form.getAttribute('data-endpoint') || '';
    var done = root.querySelector('[data-ofs-done]');

    /* Il form sparisce e al suo posto resta la conferma col numero di richiesta.
       Chi era gia' registrato vede lo stesso numero e un testo diverso: non si
       ricrea niente lato Shopify. */
    function showDone(data) {
      if (!done) {
        say(form.getAttribute('data-msg-ok'), 'ok');
        return;
      }

      var already = !!data.alreadyRegistered;
      var title = done.querySelector('[data-ofs-done-title]');
      var isNew = done.querySelector('[data-ofs-done-new]');
      var wasThere = done.querySelector('[data-ofs-done-already]');
      var id = done.querySelector('[data-ofs-done-id]');

      if (title) {
        title.textContent =
          done.getAttribute(already ? 'data-title-already' : 'data-title-new') || title.textContent;
      }
      if (isNew) isNew.hidden = already;
      if (wasThere) wasThere.hidden = !already;
      if (id) id.textContent = data.requestId || '';

      form.hidden = true;
      done.hidden = false;
      say('', 'info');

      if (done.getBoundingClientRect().top < 0) {
        done.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.reportValidity()) return;

      if (!endpoint) {
        say(form.getAttribute('data-msg-nobackend'), 'error');
        return;
      }

      if (submit) submit.disabled = true;
      say(form.getAttribute('data-msg-sending'), 'info');

      post(endpoint, form)
        .then(function (data) {
          if (!data || data.ok !== true) throw new Error('respuesta no valida');
          if (data.requestId) {
            showDone(data);
          } else {
            form.reset();
            say(form.getAttribute('data-msg-ok'), 'ok');
          }
        })
        .catch(function () {
          say(form.getAttribute('data-msg-ko'), 'error');
        })
        .finally(function () {
          if (submit) submit.disabled = false;
        });
    });
  }

  /* Recupero della foto dal codice */
  function initDownload(root) {
    var form = root.querySelector('.ofs-photo-form');
    if (!form) return;
    var say = messenger(form.querySelector('.ofs-msg'));
    var submit = form.querySelector('button[type="submit"]');
    var input = form.querySelector('input[name="codigo"]');
    var endpoint = form.getAttribute('data-endpoint') || '';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (input && input.value.trim()) || '';

      if (!code) {
        say(form.getAttribute('data-msg-nocode'), 'error');
        if (input) input.focus();
        return;
      }

      if (!endpoint) {
        say(form.getAttribute('data-msg-nobackend'), 'error');
        return;
      }

      if (submit) submit.disabled = true;
      say(form.getAttribute('data-msg-searching'), 'info');

      fetch(endpoint + (endpoint.indexOf('?') === -1 ? '?' : '&') + 'codigo=' + encodeURIComponent(code))
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          if (data && data.url) {
            say(form.getAttribute('data-msg-found'), 'ok');
            window.location.href = data.url;
          } else {
            say(form.getAttribute('data-msg-notfound'), 'error');
          }
        })
        .catch(function () {
          say(form.getAttribute('data-msg-notfound'), 'error');
        })
        .finally(function () {
          if (submit) submit.disabled = false;
        });
    });
  }

  function init() {
    document.querySelectorAll('.ofs').forEach(function (root) {
      if (root.dataset.ofsReady) return;
      root.dataset.ofsReady = '1';
      initRaffle(root);
      initDownload(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
